export const getLocalStorage =( item )=>{
    return window.localStorage.getItem(item)
}

export const setLocalStorage = (item, data) =>{
    window.localStorage.setItem(item, data);
}